var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHurtsEvenMoreSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_319_1451)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 18,
    stroke: "#ECB54F",
    strokeWidth: 3.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 41C34.2843 41 41 34.2843 41 26C41 17.7157 34.2843 11 26 11C17.7157 11 11 17.7157 11 26C11 34.2843 17.7157 41 26 41Z",
    fill: "#ECB54F",
    stroke: "#ECB54F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.375 26.375C21.7557 26.375 22.875 25.2557 22.875 23.875C22.875 22.4943 21.7557 21.375 20.375 21.375C18.9943 21.375 17.875 22.4943 17.875 23.875C17.875 25.2557 18.9943 26.375 20.375 26.375Z",
    fill: "#6C4C10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.625 26.375C33.0057 26.375 34.125 25.2557 34.125 23.875C34.125 22.4943 33.0057 21.375 31.625 21.375C30.2443 21.375 29.125 22.4943 29.125 23.875C29.125 25.2557 30.2443 26.375 31.625 26.375Z",
    fill: "#6C4C10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 33.4004C31.3163 32.7816 30.4155 32.2774 29.3721 31.9296C28.3287 31.5818 27.1728 31.4004 26 31.4004C24.8272 31.4004 23.6713 31.5818 22.6279 31.9296C21.5845 32.2774 20.6837 32.7816 20 33.4004",
    stroke: "#6C4C10",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8766 19.7162C18.2343 18.1626 19.1824 17.6152 21.2067 17.2162",
    stroke: "#6C4C10",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1201 19.7162C33.7624 18.1626 32.8143 17.6152 30.79 17.2162",
    stroke: "#6C4C10",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_319_1451",
    x: 0.0000243187,
    y: 0.00039053,
    width: 52,
    height: 51.9992,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.2,
    result: "effect1_foregroundBlur_319_1451"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHurtsEvenMoreSelected);
export default __webpack_public_path__ + "static/media/hurts-even-more-selected.1e7b17ccb94a6b530792d33239a93747.svg";
export { ForwardRef as ReactComponent };